import { Link } from 'react-router-dom';
import { ChatCircle, UsersThree, Shield, BookOpen, Heartbeat, Info, ShieldCheck } from '@phosphor-icons/react';

export default function AppFooter() {
  return (
    <footer className="bg-gradient-to-b from-pink-50 to-orange-50 dark:from-gray-900 dark:to-gray-900 border-t border-pink-100 dark:border-pink-800 py-12 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img src="/wordmark.png" alt="Romy" className="h-20 w-auto" />
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Empowering women in their health journeys through knowledge,
              advocacy, and AI-powered insights.
            </p>
          </div>
          <div>
            <h3 className="text-gray-800 dark:text-gray-100 font-bold mb-4">Platform</h3>
            <ul className="space-y-2 text-gray-500 dark:text-gray-400">
              <li>
                <Link to="/chat" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <ChatCircle size={16} />
                  Chat
                </Link>
              </li>
              <li>
                <Link to="/community" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <UsersThree size={16} />
                  Community Forum
                </Link>
              </li>
              <li>
                <Link to="/advocacy" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <Shield size={16} />
                  Advocacy
                </Link>
              </li>
              <li>
                <Link to="/research" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <BookOpen size={16} />
                  Research
                </Link>
              </li>
              <li>
                <Link to="/health" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <Heartbeat size={16} />
                  Health Tracker
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <Info size={16} />
                  About
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-gray-800 dark:text-gray-100 font-bold mb-4">Resources</h3>
            <ul className="space-y-2 text-gray-500 dark:text-gray-400">
              <li>
                <Link to="/privacy" className="hover:text-pink-600 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-pink-600 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/trust" className="hover:text-pink-600 transition-colors flex items-center gap-2">
                  <ShieldCheck size={16} />
                  How We Handle Your Data
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-pink-200/60 dark:border-pink-800/60 pt-6">
          <p className="text-xs text-gray-400 dark:text-gray-500 mb-4">
            <strong className="text-gray-500 dark:text-gray-400">Important Notice:</strong> Romy is not a substitute for
            professional medical advice, diagnosis, or treatment. Always consult your healthcare provider
            for medical decisions.
          </p>
          <p className="text-center text-sm text-gray-400 dark:text-gray-500">
            &copy; {new Date().getFullYear()} Romy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
